import React, {useState} from 'react';
import {searchUsersByName} from '../utils/dbUtils';
import {db} from '../config/firebase';
import {doc, getDoc} from 'firebase/firestore';
import {Link} from 'react-router-dom';
import lupaIcon from '../Icons/lupa.png';
import algoliaLogo from '../Icons/Algolia-logo-blue.png';
import './UserSearchBar.css';
import { useFollowing } from '../context/FollowingContext';
import profileIcon from '../Icons/profile-menu.png';

const UserSearchBar = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [foundUsers, setFoundUsers] = useState([]);
    const { following, followUser, unfollowUser } = useFollowing();

    const handleSearch = async (term) => {
        if (term.trim() === '') {
            setFoundUsers([]);
            return;
       }
        try {
            const users = await searchUsersByName(term);
            const userIds = users.map(u => u.objectID || u.id); // Asegúrate de obtener el ID
            fetchUsersWithProfile(userIds);
       } catch (error) {
            console.error('Error al buscar usuarios:', error);
       }
   };

    const fetchUsersWithProfile = async (userIds) => {
        const usersWithProfile = [];
        for (const uid of userIds) {
            const docSnap = await getDoc(doc(db, 'users', uid));
            if (docSnap.exists()) {
                const data = docSnap.data();
                usersWithProfile.push({
                    ...data,
                    objectID: uid,
               });
           }
       }
        setFoundUsers(usersWithProfile);
   };

    // Solo actualiza el estado local, la lógica de Firestore y notificación está en useFollowing
    const handleFollowUser = async (followUserId) => {
        try {
            await followUser(followUserId);
       } catch (error) {
            console.error('Error al seguir al usuario:', error);
       }
   };

    const handleUnfollowUser = async (unfollowUserId) => {
        try {
            await unfollowUser(unfollowUserId);
       } catch (error) {
            console.error('Error al dejar de seguir al usuario:', error);
       }
   };

    return (
        <div className="user-search-bar">
            <div className="search-container">
                <input
                    type="text"
                    placeholder="Busca a un usuario"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        handleSearch(e.target.value);
                   }}
                />
                <img src={lupaIcon} alt="Buscar" className="search-icon" />
                <span className="algolia-powered">
                    powered by <img src={algoliaLogo} alt="Algolia" className="algolia-logo" />
                </span>
                {foundUsers.length > 0 && (
                    <ul className="user-results">
                        {foundUsers.map((user) => (
                            <li key={user.objectID} className="user-item">
                                <Link to={`/profile/${user.objectID}`} className="user-link">
                                    <img
                                        src={user.profileImage || profileIcon}
                                        alt="Perfil"
                                        className="user-search-profile-img"
                                    />
                                    <span className="user-name">{user.name}</span>
                                </Link>
                                {following.includes(user.objectID) ? (
                                    <button
                                        type="button"
                                        className="unfollow-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUnfollowUser(user.objectID);
                                       }}
                                    >
                                        Dejar de Seguir
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="follow-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleFollowUser(user.objectID);
                                       }}
                                    >
                                        Seguir
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default UserSearchBar;